import React from "react";
import { Phone, CalendarCheck } from "lucide-react";
import { PRIMARY_TEL } from "@/data";

export const MobileCallBar = () => (
  <div data-testid="mobile-call-bar" className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-white/10 lg:hidden">
    <a
      href={`tel:${PRIMARY_TEL}`}
      data-testid="mobile-call-now"
      className="flex items-center justify-center gap-2 bg-zinc-900/95 py-4 text-xs font-medium uppercase tracking-[0.15em] text-white backdrop-blur"
    >
      <Phone className="h-4 w-4 text-primary" /> Call Now
    </a>
    <button
      onClick={() => document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" })}
      data-testid="mobile-book-online"
      className="flex items-center justify-center gap-2 bg-primary py-4 text-xs font-medium uppercase tracking-[0.15em] text-primary-foreground"
    >
      <CalendarCheck className="h-4 w-4" /> Book Online
    </button>
  </div>
);
